<template>
    <v-card class="card mt-8">
        <div class="card__header">
            <div
                    class="card__accent card__accent-icon"
                    :style="{'background-color': localColor}">
                <v-icon color="white">{{ icon }}</v-icon>
            </div>
            <div class="card__label">
                <div class="card__col">
                    <div class="card__label-top-left">{{ labelTopLeft }}</div>
                    <div class="card__label-bottom-left">{{ labelBottomLeft }}</div>
                </div>
                <div>
                    <slot name="header"></slot>
                </div>
            </div>
        </div>
        <v-card-text>
            <slot></slot>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: {
            color: {
                default: null,
                type: String
            },
            labelTopLeft: String,
            labelTopRight: String,
            labelBottomLeft: String,
            labelBottomRight: String,
            icon: {
                type: String,
                default: '$target'
            }
        },
        data() {
            return {
                localColor: null
            }
        },
        created() {
            if (this.color === null) {
                this.localColor = this.$vuetify.theme.themes.light.primary;
            }
        }
    }
</script>

<style lang="scss">
    .card {
        $accentIconWidth: 80px;
        $labelWidth: calc(100% - 80px);

        &.card_max-xs {
            max-width: 600px;
        }
        &.card_max-sm {
            max-width: 960px;
        }
        &.card_max-md {
            max-width: 1264px;
        }
        &.card_max-lg {
            max-width: 1904px;
        }
        .card__header {
            height: $accentIconWidth;
            margin: 15px 15px 0 15px;
            border-bottom: 1px solid #eee;
            position: relative;
        }
        .card__accent {
            width: 80px;
            height: 100%;
            position: absolute;
            bottom: 15px;
            border-radius: 4px;

            &.card__accent-icon {
                display: flex;
                justify-content: center;
            }
            .v-icon {
                font-size: 40px;
            }
        }
        .card__label {
            width: $labelWidth;
            height: 100%;
            position: absolute;
            right: 0;
            padding: 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .card__label-top-left {
            font-size: 15px;
            color: rgba(0, 0, 0, 0.87);
        }
        .card__label-bottom-left {
            font-size: 13px;
            color: rgba(0, 0, 0, 0.54);
        }
        .card__actions {
            display: flex;
        }
        .card__action {
            max-width: 300px;
            margin-right: 15px;

            &:last-child {
                margin-right: 0;
            }
        }
    }
</style>
